<app-z-dialog
  [title]="'COMMON.SEND_SIGNED_DOC' | translate"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #contentTemplate>  
  <section class="border rounded p-4 bg-light mb-4">
    <div class="d-flex justify-content-center gap-3">
      <z-button
        cdk-button
         [ngClass]="{
          'acoes-toggle': true,
          'selected': formGroup.controls.action.value === 'aprovar'
        }"
        [color]="'primary'"
        [matType]="'stroked'"
        [icon]="'check_circle'"
        [label]="'COMMON.APPROVE_DOC' | translate"
        (click)="formGroup.controls.action.setValue('aprovar')"
      >
      </z-button>
      <z-button
        cdk-button
         [ngClass]="{
          'acoes-toggle': true,
          'action-reprove': true,
          'selected': formGroup.controls.action.value === 'reprovar'
        }"
        [color]="'error'"
        [matType]="'stroked'"
        [icon]="'cancel'"
        [label]="'COMMON.REJECT_DOC' | translate"
        (click)="formGroup.controls.action.setValue('reprovar')"
      >
      </z-button>
    </div>
  </section>

  <app-file-uploader> </app-file-uploader>
</ng-template>

<ng-template #buttonsTemplate>
  <z-button
    [label]="'COMMON.SEND' | translate"
    icon="send"
    color="primary"
    [mat-dialog-close]="true"
    (clicked)="send()"
    cdkFocusInitial
  ></z-button>
</ng-template>
